import {TimelineLite} from "gsap";
import {DjPsycho} from "../DjPsycho";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoHotZone extends TimelineSprite {

    constructor() {
        super(DjPsycho.assetLoader.getTextures("FX_Hot_Zone/Hot_Zone_"));
        this.name = "DjPsychoHotZone";
        this.blendMode = PIXI.BLEND_MODES.ADD;
        this.hide();
        this.anchor.set(0.5);
    }

    public showHotZone(reelId: number, symId: number): void {
        this.x = (reelId * DjPsycho.symbolWidth) + (DjPsycho.symbolWidth * 0.5) + (reelId * DjPsycho.padding) + DjPsycho.reelViewX;
        this.y = (symId * DjPsycho.symbolHeight) + (symId * DjPsycho.padding) + DjPsycho.reelViewY;
        this.show();
        this.playLoop();

        // #171
        DjPsycho.soundPlayer.playSound(DjPsychoSound.BLINK);
    }

    public hideHotZone(): void {
        if (!this.visible) {
            return;
        }

        const tl: TimelineLite = new TimelineLite();

        // #171
        tl.add(() => {
            DjPsycho.soundPlayer.stopSound(DjPsychoSound.BLINK);

            DjPsycho.soundPlayer.playSound(DjPsychoSound.BLINK_ENDS);
        });

        tl.to(this, {
            duration: 0.1,
            alpha: 0
        });
        tl.add(() => {
            this.stopLoop();
            this.hide();
            this.alpha = 1;
        });
    }
}